<div class="bg-full-image" [id]="newAccountKind === '3a' ? 'tree-wrap' : 'leaf-wrap'">
  <section class="flex-container" *ngIf="newAccountKind">
    <div class="flex-row flex-justify-center">
      <div class="flex-col-4 flex-col-sm-12 cross-selling">
        <h2>{{ 'crossselling.' + newAccountKind + '.title' | translate }}</h2>
        <p class="subtitle" [innerHTML]="'crossselling.' + newAccountKind + '.intro' | translate"></p>
        <div class="info-box">
          <p class="subtitle strong">{{ 'crossselling.' + newAccountKind + '.sectionTitle' | translate }}</p>
          <div class="list">
            <div *ngFor="let item of investmentList" class="list-item">
              <span class="icon-i-checkmark-circle"></span>
              <p>
                {{
                  item
                    | translate
                      : {
                          minimumInvestment: 2000 | translateNumber: customer.language : (customer.app_location === 'ch' ? 'CHF' : 'EUR'),
                          minimumSavingsPlan: 500 | translateNumber: customer.language : (customer.app_location === 'ch' ? 'CHF' : 'EUR')
                        }
                }}
              </p>
            </div>
          </div>
        </div>

        <div class="info-box" *ngIf="newAccountKind === '3a'">
          <p class="subtitle strong">{{ 'crossselling.3a.withdrawal.sectionTitle' | translate }}</p>
          <p>{{ 'crossselling.3a.withdrawal.p1' | translate }}</p>
          <div class="withdrawal-list">
            <li>{{ 'crossselling.3a.withdrawal.li1' | translate }}</li>
            <li>{{ 'crossselling.3a.withdrawal.li2' | translate }}</li>
            <li>{{ 'crossselling.3a.withdrawal.li3' | translate }}</li>
          </div>
          <p>
            <span class="strong">{{ 'crossselling.3a.withdrawal.p2_1' | translate }}</span
            >{{
              'crossselling.3a.withdrawal.p2_2'
                | translate
                  : {
                      year: getCurrentYear(),
                      max_small_contribution: MAXIMUM_3A_CONTRIBUTION[getCurrentYear()].small,
                      max_large_contribution: MAXIMUM_3A_CONTRIBUTION[getCurrentYear()].large
                    }
            }}
          </p>
        </div>
        <button (click)="createNewAccount(newAccountKind)" class="ui-button full-width" [class.loading]="isLoading">
          <span class="icon-i-windmill"></span>
          {{ 'crossselling.' + newAccountKind + '.cta' | translate }}
        </button>
        <app-footer-3a *ngIf="newAccountKind === '3a'"></app-footer-3a>
      </div>
    </div>
  </section>
</div>
